const DelegationType = {
    Manual: 1,
    Scheduled: 2,
};
export default DelegationType;
